
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("amtnj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $2SlZp = parcelRequire("2SlZp");


var $1NBp8 = parcelRequire("1NBp8");


var $lfFzM = parcelRequire("lfFzM");

/* SpaceViewsListItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $cGtPE = parcelRequire("cGtPE");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $u9agA = parcelRequire("u9agA");


var $e66a9 = parcelRequire("e66a9");


var $9x2sR = parcelRequire("9x2sR");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $4K4h4 = parcelRequire("4K4h4");


var $6bZDi = parcelRequire("6bZDi");


var $gz8ZY = parcelRequire("gz8ZY");


var $5C17p = parcelRequire("5C17p");

parcelRequire("hySOz");
var $l0o5N = parcelRequire("l0o5N");


var $g0MxG = parcelRequire("g0MxG");


var $hXDOc = parcelRequire("hXDOc");

const $22798675b387cd1c$var$styles = {
    emojiWrapper: "_1e0c1txw _1o9zidpf _4cvr1h6o _2hwx12x7",
    nav4EmojiWrapper: "_1e0c1txw _1bah1h6o _4cvr1h6o _1o9zidpf",
    title: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
    contentIconWrapper: "_1e0c1txw _4cvr1h6o _u5f312x7",
    contentIconWrapperNav4: "_1e0c1txw _1bah1h6o _4cvr1h6o _1o9zidpf",
    grid: "_4cvr1h6o _gy1p12x7 _yv0etjho"
};
const $22798675b387cd1c$var$EmojiOrContentIcon = ({ isContentTreeIconVisible: isContentTreeIconVisible, contentType: contentType, iconColor: iconColor, displayEmoji: displayEmoji, isNav4Enabled: isNav4Enabled = false })=>{
    if (isContentTreeIconVisible && !displayEmoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: isNav4Enabled ? $22798675b387cd1c$var$styles.contentIconWrapperNav4 : $22798675b387cd1c$var$styles.contentIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4K4h4.ContentTreeIconLoader), {
        type: contentType,
        label: "",
        color: iconColor
    }));
    else if ((0, $2JGYp.isValidEmojiOrFavicon)(displayEmoji, contentType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: displayEmoji,
        height: 16,
        context: "spaceViews",
        wrapper: isNav4Enabled ? $22798675b387cd1c$var$Nav4EmojiWrapper : $22798675b387cd1c$var$EmojiWrapper,
        contentType: contentType
    });
    else return null;
};
const $22798675b387cd1c$var$HIGHLIGHT_FADE = null;
const $22798675b387cd1c$var$unboundedStyles = {
    root: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _2rkofajl _y44vglyw _1rjc12x7 _1bto1l2s _o5721q9c _1tke14no _bfhk1j28 _4t3i14no _bozgu2gc _y4ti1b66 _syazi7uo _7ggvglyw _1ieuf1ug _6ehmidpf _1kt9glyw _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hazsu _f8pjazsu _30l3azsu _1053azsu _30l3i7uo _18bl1txw _1qdc1txw _tfd31osq _1p0e1osq _10j71dpa _irr31dpa",
    isForceHoverBackground: "_7ggv1txw _1ieu1osq",
    isHighlighted: "_y44vl8ns",
    isQuickActionsFocused: "_7ggv1txw _1ieu1osq",
    isSelected: "_bfhk15s3 _9h8h1bgf _f8pj1bgf _30l31bgf _10531bgf _10j7ufnl _irr3ufnl"
};
const $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4 = {
    displayAndOpacity: "_7ggvglyw _1ieuf1ug _18bl1txw _1qdc1txw _tfd31osq _1p0e1osq",
    isQuickActionsFocused: "_7ggv1txw _1ieu1osq",
    isForceHoverBackground: "_7ggv1txw _1ieu1osq"
};
const $22798675b387cd1c$var$EmojiWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        as: "span",
        xcss: $22798675b387cd1c$var$styles.emojiWrapper
    }, children);
};
const $22798675b387cd1c$var$Nav4EmojiWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        as: "span",
        xcss: $22798675b387cd1c$var$styles.nav4EmojiWrapper
    }, children);
};
const $22798675b387cd1c$export$5cdf0e4af70a17cf = ({ title: title, url: url, onItemClick: onItemClick, isSelected: isSelected, item: item, displayEmoji: displayEmoji = '', contentType: contentType, spaceKey: spaceKey, isSuperAdmin: isSuperAdmin = false, highlight: highlight = false, isHoverPageCardOptedIn: isHoverPageCardOptedIn = false, closeAllHoverPageCards: closeAllHoverPageCards = ()=>{}, setOpenQuickActionsId: setOpenQuickActionsId, isQuickActionsOpen: isQuickActionsOpen, isQuickActionsFocused: isQuickActionsFocused, setFocusedQuickActionsId: setFocusedQuickActionsId, isEditingTitleId: isEditingTitleId, setIsEditingTitleId: setIsEditingTitleId, onEnterHoverTarget: onEnterHoverTarget = ()=>{}, onLeaveHoverTarget: onLeaveHoverTarget = ()=>{}, onBlurHoverTarget: onBlurHoverTarget = ()=>{}, shouldRenderAfterIcon: shouldRenderAfterIcon, index: index, renderTitle: renderTitle = ({ title: title })=>title })=>{
    const hoverPageCardTriggerRef = (0, $42omo.useRef)(null);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const onClick = (0, $42omo.useCallback)(()=>{
        onItemClick && onItemClick(item.id, index);
        closeAllHoverPageCards();
    }, [
        onItemClick,
        item.id,
        index,
        closeAllHoverPageCards
    ]);
    const iconColor = isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined;
    const isContentTreeIconVisible = contentType && (0, $6bZDi.includesValidContentTreeType)(contentType, isNav4Enabled);
    const isLiveDoc = contentType === 'page' && item.data.subType === 'live';
    const iconContentType = isLiveDoc ? 'liveDoc' : contentType;
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: hoverPageCardTriggerRef,
        onBlur: onBlurHoverTarget,
        onMouseEnter: ()=>onEnterHoverTarget({
                itemID: item.id.toString(),
                isQuickActionsFocused: isQuickActionsFocused,
                hoverPageCardTriggerRef: hoverPageCardTriggerRef
            }),
        onMouseLeave: onLeaveHoverTarget,
        onFocus: ()=>onEnterHoverTarget({
                itemID: item.id.toString(),
                isQuickActionsFocused: isQuickActionsFocused,
                hoverPageCardTriggerRef: hoverPageCardTriggerRef
            }),
        role: "listitem",
        className: (0, $gMc0m.default)([
            $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4.displayAndOpacity,
            isQuickActionsOpen && $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4.isForceHoverBackground,
            isQuickActionsFocused && $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4.isQuickActionsFocused
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
        name: "space-views-list-item",
        preloadUrl: url,
        preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
        testId: "space-views-list-item",
        onClick: onClick,
        href: url,
        isSelected: isSelected,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e66a9))), {
            label: ""
        }),
        elemAfter: shouldRenderAfterIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g0MxG.PageTreeAfterIconLoader), {
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            isSuperAdmin: isSuperAdmin,
            isQuickActionsOpen: isQuickActionsOpen,
            setOpenQuickActionsId: setOpenQuickActionsId,
            setIsEditingTitleId: setIsEditingTitleId,
            closeAllHoverPageCards: closeAllHoverPageCards,
            spaceKey: spaceKey,
            item: item,
            displayTitle: title,
            hideFolder: true,
            disableRename: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8SNb.default), {
        xcss: $22798675b387cd1c$var$styles.grid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22798675b387cd1c$var$EmojiOrContentIcon, {
        isContentTreeIconVisible: isContentTreeIconVisible,
        contentType: iconContentType,
        iconColor: iconColor,
        displayEmoji: displayEmoji,
        isNav4Enabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $22798675b387cd1c$var$styles.title
    }, renderTitle({
        title: title
    }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: hoverPageCardTriggerRef,
        onBlur: onBlurHoverTarget,
        onMouseEnter: ()=>onEnterHoverTarget({
                itemID: item.id.toString(),
                isQuickActionsFocused: isQuickActionsFocused,
                hoverPageCardTriggerRef: hoverPageCardTriggerRef
            }),
        onMouseLeave: onLeaveHoverTarget,
        onFocus: ()=>onEnterHoverTarget({
                itemID: item.id.toString(),
                isQuickActionsFocused: isQuickActionsFocused,
                hoverPageCardTriggerRef: hoverPageCardTriggerRef
            }),
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
        name: "space-views-list-item",
        preloadUrl: url,
        preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l0o5N.ConditionalInlineRename), {
        id: item.id,
        displayEmoji: displayEmoji,
        title: title,
        isEditingTitle: isEditingTitleId === item.id,
        setIsEditingTitleId: setIsEditingTitleId,
        setFocusedQuickActionsId: setFocusedQuickActionsId,
        updateContentTreeItem: $22798675b387cd1c$var$noop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5C17p.ConditionalTreeItemTooltip), {
        title: title,
        isHoverPageCardOptedIn: isHoverPageCardOptedIn,
        isQuickActionsOpen: isQuickActionsOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
        testId: "space-views-list-item",
        onClick: onClick,
        href: url,
        isSelected: isSelected,
        iconAfter: shouldRenderAfterIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g0MxG.PageTreeAfterIconLoader), {
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            isSuperAdmin: isSuperAdmin,
            isQuickActionsOpen: isQuickActionsOpen,
            setOpenQuickActionsId: setOpenQuickActionsId,
            setIsEditingTitleId: setIsEditingTitleId,
            closeAllHoverPageCards: closeAllHoverPageCards,
            spaceKey: spaceKey,
            item: item,
            displayTitle: title,
            hideFolder: true,
            disableRename: true
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e66a9))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22798675b387cd1c$var$EmojiOrContentIcon, {
            isContentTreeIconVisible: isContentTreeIconVisible,
            contentType: iconContentType,
            iconColor: iconColor,
            displayEmoji: displayEmoji
        })),
        className: (0, $gMc0m.default)([
            $22798675b387cd1c$var$unboundedStyles.root,
            isSelected && $22798675b387cd1c$var$unboundedStyles.isSelected,
            isQuickActionsOpen && $22798675b387cd1c$var$unboundedStyles.isForceHoverBackground,
            highlight && $22798675b387cd1c$var$unboundedStyles.isHighlighted,
            isQuickActionsFocused && $22798675b387cd1c$var$unboundedStyles.isQuickActionsFocused
        ])
    }, renderTitle({
        title: title
    }))))));
};
const $22798675b387cd1c$var$noop = ()=>{};


const $1be42622e87811bc$var$getUrlByType = (type)=>{
    const typeToUrl = {
        page: (0, $1NBp8.VIEW_PAGE),
        whiteboard: (0, $1NBp8.WHITEBOARD_BOARD),
        database: (0, $1NBp8.DATABASE_VIEW),
        embed: (0, $1NBp8.EMBED_VIEW)
    };
    return type && typeToUrl[type] ? typeToUrl[type] : (0, $1NBp8.VIEW_PAGE);
};
const $1be42622e87811bc$export$73023ca5401d91bc = ({ pagesList: pagesList, onItemClick: onItemClick, spaceKey: spaceKey, contentId: contentId, highlightedPages: highlightedPages = [], isHoverPageCardOptedIn: isHoverPageCardOptedIn, closeAllHoverPageCards: closeAllHoverPageCards = ()=>{}, onEnterHoverTarget: onEnterHoverTarget = ()=>{}, onLeaveHoverTarget: onLeaveHoverTarget = ()=>{}, onBlurHoverTarget: onBlurHoverTarget = ()=>{}, shouldRenderAfterIcon: shouldRenderAfterIcon, renderTitle: renderTitle = ({ title: title })=>title })=>{
    const intl = (0, $8C5kA.default)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const [openQuickActionsId, setOpenQuickActionsId] = (0, $42omo.useState)(null);
    const [focusedQuickActionsId, setFocusedQuickActionsId] = (0, $42omo.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
        role: "list"
    }, pagesList.map(({ title: title, id: id, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions, displayEmoji: displayEmoji, type: type, subType: subType }, index)=>{
        const isCurrentPage = Boolean(contentId && contentId === id);
        let parsedId = id;
        // databases and embeds currently have their id returned as 'activation/ACTIVATION_ID/ENTITY_ID', so we are parsing the entity id
        if ((type === 'database' || type === 'embed') && id) parsedId = id.split('/').pop() || null;
        const contentLink = parsedId && spaceKey ? $1be42622e87811bc$var$getUrlByType(type).toUrl({
            spaceKey: spaceKey,
            contentId: parsedId
        }) : '';
        const item = {
            id: parsedId || '',
            hasRestrictions: hasRestrictions,
            hasInheritedRestrictions: hasInheritedRestrictions,
            data: {
                type: type,
                subType: subType
            }
        };
        const highlight = id ? highlightedPages.includes(id) : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22798675b387cd1c$export$5cdf0e4af70a17cf), {
            intl: intl,
            url: contentLink,
            title: title || ' ',
            displayEmoji: displayEmoji,
            contentType: type,
            onItemClick: onItemClick,
            key: id,
            index: index,
            isSelected: isCurrentPage,
            spaceKey: spaceKey || '',
            item: item,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            closeAllHoverPageCards: closeAllHoverPageCards,
            highlight: highlight,
            isSuperAdmin: isSuperAdmin,
            isQuickActionsOpen: openQuickActionsId === item.id,
            setOpenQuickActionsId: setOpenQuickActionsId,
            isQuickActionsFocused: focusedQuickActionsId === item.id,
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            isEditingTitleId: null,
            setIsEditingTitleId: $1be42622e87811bc$var$noop,
            onEnterHoverTarget: onEnterHoverTarget,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            renderTitle: renderTitle
        });
    })));
};
const $1be42622e87811bc$var$noop = ()=>Promise.resolve();
module.exports["SpaceViewsList"] = $1be42622e87811bc$export$73023ca5401d91bc;

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("4K4h4", function(module, exports) {
$parcel$export(module.exports, "ContentTreeIcon", () => (parcelRequire("iU0gR")).ContentTreeIcon);

var $jmjWc = parcelRequire("jmjWc");


var $iU0gR = parcelRequire("iU0gR");


const $61f85e63c6992485$export$e511f243d20dd25e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g-l5_",
    name: "ContentTreeIconLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("iU0gR")))).ContentTreeIcon
});
module.exports["ContentTreeIconLoader"] = $61f85e63c6992485$export$e511f243d20dd25e;

});

parcelRegister("iU0gR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $eG1e2 = parcelRequire("eG1e2");


var $5tmwS = parcelRequire("5tmwS");


var $e0ycV = parcelRequire("e0ycV");

const $3b6036244b1fd25e$export$160f5c89496b5ea9 = ({ label: label, color: color, spacing: // can override default icon color
spacing, type: type, isExpanded: isExpanded = false })=>{
    const contentTreeIconTypes = {
        page: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        whiteboard: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        database: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        folder: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))) : (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        liveDoc: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV)))
    };
    const icon = contentTreeIconTypes[type];
    const testId = `content-tree-icon${spacing !== 'none' ? `-${spacing}` : ''}-${type}${type === 'folder' && isExpanded ? '-open' : ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(icon, {
        spacing: spacing,
        label: label,
        color: color,
        testId: testId
    });
};
module.exports["ContentTreeIcon"] = $3b6036244b1fd25e$export$160f5c89496b5ea9;

});

parcelRegister("6bZDi", function(module, exports) {
const $a8768b1a0c8c67c8$export$ee7a362b3ed8b036 = [
    'page',
    'whiteboard',
    'database',
    'folder',
    'liveDoc'
];
const $a8768b1a0c8c67c8$export$a73714094b2817b7 = (obj)=>typeof obj === 'string' && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(obj);
const $a8768b1a0c8c67c8$export$204659eac14d740b = (obj)=>$a8768b1a0c8c67c8$export$a73714094b2817b7(obj) ? obj : undefined;
const $a8768b1a0c8c67c8$export$c7c48cc42c0546b7 = (contentType, isNav4Enabled)=>{
    const contentTreeType = $a8768b1a0c8c67c8$export$204659eac14d740b(contentType);
    if (!isNav4Enabled && contentTreeType === 'page') return false;
    return !!contentTreeType && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(contentTreeType);
};
module.exports["isContentTreeType"] = $a8768b1a0c8c67c8$export$a73714094b2817b7;
module.exports["includesValidContentTreeType"] = $a8768b1a0c8c67c8$export$c7c48cc42c0546b7;

});

parcelRegister("5C17p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6p02T = parcelRequire("6p02T");


var $aU0Vx = parcelRequire("aU0Vx");

const $2703b103d1a678c3$export$cba03ec732da70ea = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn, children: children, title: title, isQuickActionsOpen: isQuickActionsOpen } = t0;
    let t1;
    if ($[0] !== children || $[1] !== isHoverPageCardOptedIn || $[2] !== isQuickActionsOpen || $[3] !== title) {
        t1 = isHoverPageCardOptedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aU0Vx.PageTreeTooltip), {
            title: (0, $6p02T.cleanExcerpt)(title),
            isQuickActionsOpen: isQuickActionsOpen
        }, children);
        $[0] = children;
        $[1] = isHoverPageCardOptedIn;
        $[2] = isQuickActionsOpen;
        $[3] = title;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ isHoverPageCardOptedIn: isHoverPageCardOptedIn, children: children, title: title, isQuickActionsOpen: isQuickActionsOpen })=>{
    return isHoverPageCardOptedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aU0Vx.PageTreeTooltip), {
        title: (0, $6p02T.cleanExcerpt)(title),
        isQuickActionsOpen: isQuickActionsOpen
    }, children);
};
module.exports["ConditionalTreeItemTooltip"] = $2703b103d1a678c3$export$cba03ec732da70ea;

});

parcelRegister("6p02T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("aU0Vx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");

const $17e4300d7b59a3d4$export$6c94635022fac1d1 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, title: title, isQuickActionsOpen: isQuickActionsOpen } = t0;
    const t1 = !isQuickActionsOpen && title ? title : null;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t1,
            position: "top",
            delay: 750,
            hideTooltipOnMouseDown: true
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children, title: title, isQuickActionsOpen: isQuickActionsOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: !isQuickActionsOpen && title ? title : null,
        position: "top",
        delay: 750,
        hideTooltipOnMouseDown: true
    }, children);
module.exports["PageTreeTooltip"] = $17e4300d7b59a3d4$export$6c94635022fac1d1;

});

parcelRegister("hySOz", function(module, exports) {
$parcel$export(module.exports, "ConditionalInlineRename", () => (parcelRequire("l0o5N")).ConditionalInlineRename);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $l0o5N = parcelRequire("l0o5N");


const $4938a4ac4072e24f$export$5dca550a712dab6d = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uk9Wl",
    name: "PageTreeQuickActions",
    loader: async ()=>(await (parcelRequire("irljW"))).PageTreeQuickActions
});

const $4938a4ac4072e24f$export$fd6f8aa63961aeed = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0zuTW",
    name: "InlineRename",
    loader: async ()=>(await (parcelRequire("8ZiT9"))).InlineRename,
    loading: ({ children: children })=>children
});
module.exports["PageTreeQuickActions"] = $4938a4ac4072e24f$export$5dca550a712dab6d;
module.exports["InlineRename"] = $4938a4ac4072e24f$export$fd6f8aa63961aeed;

});

parcelRegister("irljW", function(module, exports) {

let $d6cb4970771be651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d6cb4970771be651$var$load("6wr18"),
    $d6cb4970771be651$var$load("ffEVr"),
    $d6cb4970771be651$var$load("clpSH")
]).then(()=>parcelRequire('cAbTs'));

});

parcelRegister("8ZiT9", function(module, exports) {

let $68b2ac180417c10c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $68b2ac180417c10c$var$load("eUy1m"),
    $68b2ac180417c10c$var$load("3yFw0"),
    $68b2ac180417c10c$var$load("be8k3"),
    $68b2ac180417c10c$var$load("6wr18"),
    $68b2ac180417c10c$var$load("dlm6q"),
    $68b2ac180417c10c$var$load("Wowvf"),
    $68b2ac180417c10c$var$load("7EorR"),
    $68b2ac180417c10c$var$load("ffEVr"),
    $68b2ac180417c10c$var$load("kHOMt"),
    $68b2ac180417c10c$var$load("hhss7"),
    $68b2ac180417c10c$var$load("4izLy"),
    $68b2ac180417c10c$var$load("PNyg1")
]).then(()=>parcelRequire('7K7RC'));

});

parcelRegister("l0o5N", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hySOz = parcelRequire("hySOz");

const $208c4dcc8619080d$export$2305c9520b042855 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let isEditingTitle;
    let props;
    if ($[0] !== t0) {
        ({ children: children, isEditingTitle: isEditingTitle, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isEditingTitle;
        $[3] = props;
    } else {
        children = $[1];
        isEditingTitle = $[2];
        props = $[3];
    }
    if (isEditingTitle) {
        let t1;
        if ($[4] !== children || $[5] !== isEditingTitle || $[6] !== props) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hySOz.InlineRename), {
                ...props,
                isEditingTitle: isEditingTitle
            }, children);
            $[4] = children;
            $[5] = isEditingTitle;
            $[6] = props;
            $[7] = t1;
        } else t1 = $[7];
        return t1;
    }
    let t1;
    if ($[8] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
        $[8] = children;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : ({ children: children, isEditingTitle: isEditingTitle, ...props })=>{
    if (isEditingTitle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hySOz.InlineRename), {
        ...props,
        isEditingTitle: isEditingTitle
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
};
module.exports["ConditionalInlineRename"] = $208c4dcc8619080d$export$2305c9520b042855;

});

parcelRegister("g0MxG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ab7921964510845f$export$e3668039106e3bc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CQdGh",
    name: "PageTreeAfterIconLoader",
    loader: async ()=>(await (parcelRequire("8m9Vr"))).PageTreeAfterIcon
});
module.exports["PageTreeAfterIconLoader"] = $ab7921964510845f$export$e3668039106e3bc;

});

parcelRegister("8m9Vr", function(module, exports) {

let $615813c87f230984$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $615813c87f230984$var$load("6wr18"),
    $615813c87f230984$var$load("ffEVr"),
    $615813c87f230984$var$load("dkv9z")
]).then(()=>parcelRequire('4Nj9v'));

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader",
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: onMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseDown
    }, children));
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) {
        if ((0, $6mKj3.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": `hover-preloader-${props.name}`,
            "data-testid": "hover-preloader"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});


//# sourceMappingURL=SpaceViewsList.26f0e981.js.map
